import React from 'react';
import { useNavigate } from 'react-router';
import { observer } from 'mobx-react-lite';
import { ChevronLeftIcon } from '@radix-ui/react-icons';
import { IconButton } from '@producer/ui-kit';

import { uiStore } from '../../core/stores/ui-store';
import { DrawerIcon } from '../../components/icons/drawer-icon';
import { useOnClickOutside } from '../../hooks/useOutsideClick';
import { NotificationCenter } from './notification-center';
import { globalConfig } from '../../configuration/config';
import { NovuProvider } from '@novu/react';
import { authStore } from '../../core/stores/auth-store';

import styles from './mobile-header.module.scss';
interface Props {
  hasSpace?: boolean;
}

export const MobileHeader: React.FC<Props> = observer(({ hasSpace }) => {
  const navigate = useNavigate();
  const currentUser = authStore.currentUser;

  const handleDrawerClose = () => uiStore.contextDrawer?.close();
  const { ref } = useOnClickOutside(handleDrawerClose);

  const handleBack = () => {
    navigate(-1);
  };

  const goTo = () => {
    const href = uiStore.pageTitle?.href;
    if (!href) {
      return;
    }

    navigate(href);
  };

  return (
    <div className={styles['header']}>
      <div className={styles['left']} data-with-padding={hasSpace}>
        <div
          className={styles['menu-trigger']}
          id="left-drawer-trigger"
          onClick={() => (uiStore.isDrawerOpen = !uiStore.isDrawerOpen)}
        >
          <DrawerIcon />
        </div>

        {uiStore.showBack && (
          <IconButton
            icon={<ChevronLeftIcon color="var(--color-grayscale-anti-flash-white)" />}
            onClick={handleBack}
          />
        )}

        {uiStore.pageTitle && (
          <div className={styles['title']} onClick={goTo}>
            {uiStore.pageTitle.label}
          </div>
        )}
      </div>

      <div className={styles['right']}>
        <NovuProvider
          subscriber={`user:${currentUser?._id}`}
          applicationIdentifier={globalConfig.config.novuAppIdentifier}
        >
          <NotificationCenter />
        </NovuProvider>

        <div
          className={styles['drawer-container']}
          id="contextual-drawer"
          ref={ref}
          data-hide={!uiStore.contextDrawer}
        >
          {uiStore.contextDrawer && (
            <div
              className={styles['mobile-drawer-trigger']}
              onClick={() => uiStore.contextDrawer!.toggle()}
            >
              <DrawerIcon />
            </div>
          )}
        </div>

        {uiStore.action && (
          <span className={styles['action']} onClick={uiStore.action as any}>
            Save
          </span>
        )}
      </div>
    </div>
  );
});
